export class IntelligentActionContentResult {
    applicationId: string;
    ruleName: string;
    instanceId: number;
    associatedFile?: string;
    promptName: string;
    promptVersion: number;
    resultStatus: string;
    displayText?: string;
    isCorrect?: boolean;
    isArchived: boolean;
    isAIGenerated?: boolean;
    content: any;

}